module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAJElEQVQ4T2NgGBxAu/4/Ov5z1xEFf9Ewx8CjBowaMNgMGNIAAPQCY0mH8v/HAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/RO.png
// module id = 1251
// module chunks = 0